//PHKL Custom -s
import { getI18n } from "react-i18next";
import { PruToast } from "../../../../components/pru-toast";
//PHKL Custom -e
import { OtpContextEnum, UserTypeEnum } from "../../../common/network/enum";
import { validateOtp } from "../../../prudna/network/network";
import { handlerError } from "./handle-otp-error";

export const validateOtpFunc = async (props: {
  context: OtpContextEnum;
  otp: string;
  regionCode: string;
  phone: string;
  userType: UserTypeEnum;
}) => {
  const { context, otp, regionCode, phone, userType } = props;
  try {
    const res = await validateOtp({
      context: context,
      username: `${regionCode} ${phone}`,
      otp: otp,
      userType: userType,
    });
    return handlerError(res);
  } catch (e) {
    //PHKL Custom -s
    const errorReturn = handlerError(e);
    if (typeof errorReturn === "boolean" && errorReturn) {
      PruToast({
        message: getI18n().t("Common.server_error"),
        duration: 3000,
      });
      return false;
    }
    return errorReturn;
    //PHKL Custom -e
  }
};
